import React from 'react';
import DrcUploadUtilities from '../Utilities/DrcUploadUtilities';
import DrcButton from './DrcButton';
import DrcDialog from './DrcDialog';
import DrcBackdrop from './DrcBackdrop';
import { DuUploadUtilities, DuThemeUtilities, DuDateUtilities } from 'driscolls-react-utilities';
import { withStyles } from '@material-ui/core/styles';
// Use DrcIcon
import CloudUploadOutlinedIcon from '@material-ui/icons/CloudUploadOutlined';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

var styles = (theme) => ({
    dragArea: {
        width: '100%',
        height: 200,
        border: '2px dashed #888',
        padding: 35,
        margin: '40px 0 10px',
        borderRadius: 10,
        textAlign: 'center',
        justifyContent: 'center'
    },
    uploadBtn: {
        textTransform: 'none'
    },
    submitBtn: {
        width: 150,
        margin: '20px auto',
        display: 'block',
        textAlign: 'center'
    }
});

class DrcFileUpload extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            fileName: '',
            isDropInitiated: false,
            sheetSelected: '',
            file: null,
            stats: {},
            sheetDialogOpen: false,
            isLoading: false
        };

        this.dropElement = React.createRef();
        this.inputElement = React.createRef();
    }

    componentDidMount() {
        //this.connectDrop();
        //this.setState({ fileName: this.props.fileName });
        this.props.removeUpload(this.removeUploadedFile.bind(this));
    }

    //To remove uploaded file on click of cancel
    removeUploadedFile() {
        this.inputElement.current.value = '';
        //Needed for component to rerender
        this.setState({ fileName: '' });
    }

    componentDidUpdate() {
        this.connectDrop();
    }

    statusUpdate = (status) => {
        console.log(status.message);

        if (status.message === 'Starting to Open File') {
            this.showLoadingScreen(
                <React.Fragment>
                    <h4 style={{ fontSize: '1.5rem' }}>Processing File (Step 1 of 2)</h4>
                    <div>It can take a few seconds to a couple of minutes based on the file size</div>
                </React.Fragment>
            );
        }
    };

    connectDrop = () => {
        if (!this.state.isDropInitiated && this.dropElement.current != null) {
            this.setState({ isDropInitiated: true });
            DuUploadUtilities.CreateFileDrop(this.dropElement.current, this.handleFile, this.statusUpdate, this.props.fileTypeOptions);
        }
    };

    handleFile = async (data, stats) => {
        if (data === null) {
            this.setState({
                fileName: <div style={{ color: DuThemeUtilities.DefaultColors.primary.red }}>{stats.message}</div>
            });
            this.hideLoadingScreen();
            return;
        }

        this.hideLoadingScreen();
        if (this.props.enableMultiSheet) {
            this.setState({ fileName: stats.fileName });
            this.props.parsed({ data: data, fileName: stats.fileName });
        } else if ((data.SheetNames || []).length === 1) {
            this.handleSheet(data, data.SheetNames[0], stats);
        } else {
            //open a dialog to let user choose
            this.setState({
                file: data,
                stats: stats,
                sheetDialogOpen: true,
                sheetSelected: ''
            });
        }
    };

    handleSheet = async (data, sheetName, stats) => {
        const processSheetStartTime = new Date();
        this.showLoadingScreen(
            <React.Fragment>
                <h4 style={{ fontSize: '1.5rem' }}>Processing Sheet (Step 2 of 2)</h4>
                <div>It can take a few seconds to a couple of minutes based on the file size</div>
            </React.Fragment>
        );

        const readData = await DuUploadUtilities.ReadRows(data, sheetName);
        this.hideLoadingScreen();

        if (readData.length <= 0) {
            this.setState({
                fileName: <div style={{ color: DuThemeUtilities.DefaultColors.primary.red }}>No data found. Please upload a file with data.</div>
            });
            return;
        }

        console.log(`Took ${stats.timeElapsed} to process file and ${DuDateUtilities.TimeSpanToString(processSheetStartTime, new Date())} to process the sheet`);
        this.setState({ fileName: stats.fileName });
        this.props.parsed({ data: readData, fileName: stats.fileName });
    };

    chooseSheetDialog = async () => {
        await this.handleSheet(this.state.file, this.state.sheetSelected, this.state.stats);
        this.closeSheetDialog();
    };

    closeSheetDialog = () => {
        this.setState({
            file: null,
            stats: null,
            sheetDialogOpen: false,
            sheetSelected: ''
        });
    };

    handleRadioButtonChange = (sheetName) => {
        this.setState({ sheetSelected: sheetName });
    };

    showLoadingScreen() {
        this.setState({
            isLoading: true
        });
    }

    hideLoadingScreen() {
        this.setState({
            isLoading: false
        });
    }

    render() {
        const { classes } = this.props;
        this.connectDrop();
        return (
            <div className="row" style={{ justifyContent: 'center' }}>
                <div className="col-xs-6">
                    <div
                        ref={this.dropElement}
                        className={classes.dragArea}
                        onDragOver={(ev) => {
                            ev.preventDefault();
                        }}
                    >
                        <CloudUploadOutlinedIcon fontSize="large" />
                        <div style={{ fontSize: '1.5rem' }}>Drag & Drop file here</div>
                        <div style={{ fontSize: '1.5rem' }}>or</div>
                        <div className="row" style={{ justifyContent: 'center' }}>
                            <div className="col-xs-4">
                                <DrcButton
                                    isSecondary
                                    className={classes.uploadBtn}
                                    onClick={() => {
                                        this.inputElement.current.click();
                                    }}
                                >
                                    Select File
                                </DrcButton>
                            </div>
                        </div>
                        <br />
                        {this.state.fileName}
                    </div>
                    <div style={{ display: 'none' }}>{DrcUploadUtilities.FileInput(this.handleFile, this.inputElement, this.statusUpdate, this.props.fileTypeOptions)}</div>
                </div>
                <DrcDialog
                    title="Please choose which sheet to use"
                    open={this.state.sheetDialogOpen}
                    buttons={
                        <div style={{ float: 'right', marginRight: -8 }}>
                            <DrcButton isSecondary onClick={this.closeSheetDialog}>
                                Stop Processing
                            </DrcButton>
                            <DrcButton disabled={this.state.sheetSelected === ''} isPrimary onClick={this.chooseSheetDialog}>
                                Continue
                            </DrcButton>
                        </div>
                    }
                >
                    <div className="row">
                        {this.state.file !== null
                            ? this.state.file.SheetNames.map((sheetName, index) => (
                                  <div className="col-xs-6" key={'sheet' + index}>
                                      <FormControlLabel
                                          name={sheetName}
                                          value={sheetName}
                                          control={<Radio checked={this.state.sheetSelected === sheetName} onChange={() => this.handleRadioButtonChange(sheetName)} />}
                                          label={sheetName}
                                      />
                                  </div>
                              ))
                            : null}
                    </div>
                </DrcDialog>
                <DrcBackdrop isLoading show={this.state.isLoading} />
            </div>
        );
    }
}

export default withStyles(styles)(DrcFileUpload);
